import { useRouter } from 'next/router';
import { useState } from 'react';

import { ISettlements } from '@/modules/Settlements/types';

export const useGoogleSheets = ({ fileName }: { fileName: string }) => {
  const [isLoading, setLoading] = useState(false);
  const { locale } = useRouter();
  const exportToGoogleSheet = async (
    data:
      | ISettlements.ISettlementDetailsDayInstance[]
      | ISettlements.IWorkerSettlementDaySchema[]
  ) => {
    setLoading(true);
    try {
      const response = await fetch('/api/exportToSheet', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          language: locale || 'en',
        },
        body: JSON.stringify(data),
      });

      // Check if the response was successful
      if (response.ok) {
        // Create a blob from the response data (assuming it's a file)
        const blob = await response.blob();

        // Create a temporary anchor element
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // The filename you want to save as
        a.download = `${fileName || 'aydi-settlement'}.xlsx`;
        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
      } else {
        const result = await response.json();
        if (result.url) {
          window.open(result.url, '_blank');
        }
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      // eslint-disable-next-line no-console
      console.error('Error exporting data to Google Sheet:', error);
    }
  };

  return {
    exportToGoogleSheet,
    isLoading,
  };
};
